// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownUserInfo_root_3yfcw","name":"DropdownUserInfo_name_3klnx","phone":"DropdownUserInfo_phone_2RVVa"};